export default {
  'admin': 'Administrador',
  'users': 'Usuarios',
  'assets': 'Activos',
};